// extracted by mini-css-extract-plugin
export var item = "SearchResults-module--item--12615";
export var pagination = "SearchResults-module--pagination--d16e3";
export var searchResults = "SearchResults-module--search-results--7f25e";